export const ADD_ACTIVITY = 'addActivity';
export const ADD_FAVORITE = 'addFavorite';
export const EMBLEM_AGE_VERIFICATION = 'emblemAgeVerification';
export const REMOVE_ACTIVITY = 'removeActivity';
export const REMOVE_FAVORITE = 'removeFavorite';
export const REMOVE_RATING = 'removeRating';
export const SET_RATING = 'setRating';
export const SETTINGS_SET_VALUE = 'settingsSetValue';
